<template lang="pug">
form(@submit.prevent="navigate('sistema.docModelos.new.assuntos')")
  p.text-large - Informações de Reincidência
  .columns
    .column.col-6.col-md-8.col-sm-12
      .columns
        .column.col-12
          form-group(label="Prazo para reincidência (Dias)" :validation="$v.resource.params.osm.reincidencia.prazo_considerar")
            input.form-input(v-model.number="$v.resource.params.osm.reincidencia.prazo_considerar.$model" type="number")
            .form-input-hint Após este prazo não será considerado reincidência
      .columns(v-if="resource.params.osm.reincidencia.prazo_considerar > 0")
        .column.col-12
          form-group(label="Prazos para regularizar" :class="{'has-error': invalidPrazos}")
            prazo-reincidencia(v-model="$v.resource.params.osm.reincidencia.prazos.$model")
            .form-input-hint Obrigatório informar os prazos
        .column.col-12
          form-group(label="Quantidade limite" :validation="$v.resource.params.osm.reincidencia.limite")
            input.form-input(v-model.number="$v.resource.params.osm.reincidencia.limite.$model" type="number")
            .form-input-hint Quantidade de Autos de reincidência (o auto inicial não conta).
        .column.col-12
          form-group(label="Multiplicador" :validation="$v.resource.params.osm.reincidencia.multiplicador")
            input.form-input(v-model.number="$v.resource.params.osm.reincidencia.multiplicador.$model" step="0.01" type="number")
        .column.col-12
          form-group(label="Origem da base de cálculo" :validation='$v.resource.params.osm.reincidencia.origem_ultimo_valor')
           select.form-select(v-model='$v.resource.params.osm.reincidencia.origem_ultimo_valor.$model')
              option(:value='true') Valor da última autuação
              option(:value='false') Valor atual da irregularidade
        .column.col-12
          .form-group
            label.form-switch
              input(type="checkbox" v-model="$v.resource.params.osm.reincidencia.permite_desconto.$model")
              i.form-icon
              | Permite desconto
  .pt-2
    .divider
    button.btn.btn-primary(:disabled="$v.resource.$invalid || invalidPrazos")
      btn-content(name="next")
</template>

<script>
import { minValue, required } from 'vuelidate/lib/validators'
import createMixin from './mixin'
import PrazoReincidencia from '../components/PrazoReincidencia.vue'

export default {
  mixins: [createMixin],
  components: { PrazoReincidencia },
  computed: {
    invalidPrazos() {
      const prazos = this.resource.params.osm.reincidencia.prazos
      if (this.resource.params.osm.reincidencia.prazo_considerar > 0) {
        if (Array.isArray(prazos)) {
          return prazos.length === 0
        } else {
          return Object.values(prazos).length === 0
        }
      }
      return false
    },
  },
  validations() {
    return {
      resource: {
        params: {
          osm: {
            reincidencia: {
              prazo_considerar: { required, minValue: minValue(0) },
              limite: { required, minValue: minValue(0) },
              multiplicador: { required, minValue: minValue(1) },
              origem_ultimo_valor: { required },
              permite_desconto: { required },
              prazos: {},
            },
          },
        },
      },
    }
  },
}
</script>
